<template>
  <div>
    <el-upload
      ref="fileUpload"
      :http-request="uploadFile"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :on-exceed="handleExceed"
      :file-list="externalFileList"
      :before-upload="beforeUpload"
      :on-change="handleChange"
      :limit="10"
      action=""
      multiple
      accept=".pdf,.doc,.docx,.xls,.xlsx"
    >
      <el-button round type="default" icon="el-icon-upload2">檔案上傳</el-button>
      <div slot="tip" style="color:#c0c4cc;margin:0;line-height:2.2;">
        僅支援上傳 PDF、Word、Excel 檔案 <br />
        最多可上傳 10 個檔案，每個檔案大小不得超過 10MB
      </div>
    </el-upload>
  </div>
</template>

<script>
import request from '@utils/request'

export default {
  name: 'FileUpload',
  props: {
    externalFileList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cacheList: [],
    }
  },
  methods: {
    uploadFile({ file }) {
      this.cacheList.push(file)
    },
    async handleUpload() {
      if (this.cacheList.length === 0) return []

      const formData = new FormData()
      this.cacheList.forEach((f, index) => {
        formData.append('files[]', f, f.name || `file-${index}`)
      })

      const res = await request.post('/admin/comment/file/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      const files = res.items.files || []

      this.cacheList = []
      return files
    },

    handleRemove(file, fileList) {
      this.$emit('update:externalFileList', fileList)
      this.emitExternalWithoutCache(fileList)
      this.$message.success(`已成功移除 ${file.name}`)
    },
    handleExceed(files, fileList) {
      this.$message.error(`上限為10個文件，現在上傳 ${files.length} 個文件，共選擇了 ${files.length + fileList.length} 個文件`)
    },
    beforeRemove(file) {
      return this.$confirm(`確定移除 ${file.name}？`, '是否移除文件', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 額外移除 cacheList 裡的檔案
          this.cacheList = this.cacheList.filter((f) => f.uid !== file.uid)
          return true // 告訴 el-upload 可以繼續移除
        })
        .catch(() => false)
    },
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('檔案大小不得超過 10MB')
      }
      return isLt10M
    },
    handleChange(file, fileList) {
      this.$emit('update:externalFileList', fileList)
      this.emitExternalWithoutCache(fileList)
    },
    emitExternalWithoutCache(currentFileList) {
      const externalWithoutCache = currentFileList.filter((f) => f.status === 'success')
      this.$emit('emitCleanExternal', externalWithoutCache)
    },
  },
}
</script>
